<ng-container *ngIf="control; else skeleton">
<dk-ctl-sablon #sablonCmp
    [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode" [title]="title" [code]="code"
    (handleValueChange)="handleValueChange($event)" (codeChanges)="code = $event" [warningMessage]="warningMessage"
    (searchClick)="searchClick()" [validationRules]="validationRulesMap" [validationV2]="validationV2"
    (clear)="clear()">
</dk-ctl-sablon>
    <dx-popup *ngIf="crudPopupVisible"
    title="{{labelText}}&nbsp;İmza Yetki Arama"
    [resizeEnabled]="false"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="crudPopupVisible"
    (onHiding)="closePopupAfter($event, sablonCmp)"
>
        <dk-ctl-tem-imza-yetki-arama
        [control]="control"
        (closePopup)="closePopupAfter($event, sablonCmp)"
        ></dk-ctl-tem-imza-yetki-arama>
</dx-popup>
<dx-toast [(visible)]="toastVisible" type="error" [message]="toastMessage">
</dx-toast>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>
